import React from 'react';
import { motion } from 'framer-motion';
import { CtaButton } from './CtaButton';
export function HeroSection() {
  return <section className="relative pt-16 pb-20 md:pt-24 md:pb-32 px-4 overflow-hidden bg-navy-900" data-id="element-133">
      {/* Background glow effect */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-gold-500/5 rounded-full blur-3xl pointer-events-none" data-id="element-134" />

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-135">
        <div className="text-center mb-12" data-id="element-136">
          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="text-4xl md:text-5xl lg:text-6xl font-bold text-gold-500 leading-tight mb-6" data-id="element-137">
            Cómo Eliminar tus Deudas de Retail y Consumo en Chile en menos de 90
            Días Sin Pedir Préstamos, Sin Abogados Caros y Sin Perder el Sueño
          </motion.h1>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="text-xl md:text-2xl text-gray-300 italic max-w-4xl mx-auto font-light" data-id="element-138">
            — Incluso Si Hoy Sientes que la "Bicicleta" es Infinita y el Banco
            No Para de Llamarte —
          </motion.p>
        </div>

        <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-139">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.8,
          delay: 0.4
        }} className="relative" data-id="element-140">
            <div className="absolute inset-0 bg-gradient-to-tr from-gold-500/20 to-transparent rounded-2xl blur-xl" data-id="element-141" />
            <img src="https://cdn.magicpatterns.com/uploads/eZsr2XvZZA7C7bB1ET44YZ/foto_principal_2.png" alt="Protocolo Adiós Deudas Chile 2025" className="relative z-10 w-full h-auto drop-shadow-2xl" data-id="element-142" />
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.8,
          delay: 0.6
        }} className="flex flex-col justify-center space-y-8" data-id="element-143">
            <p className="text-lg md:text-xl text-gray-200 leading-relaxed border-l-4 border-gold-500 pl-6" data-id="element-144">
              Detén el acoso de cobranza, blinda tu sueldo legalmente y recupera
              tu tranquilidad financiera usando las mismas leyes que el banco no
              quiere que conozcas.
            </p>

            <div className="pt-4" data-id="element-145">
              <CtaButton data-id="element-146" />
            </div>

            <div className="flex items-center justify-center gap-4 text-sm text-gray-400" data-id="element-147">
              <span className="flex items-center gap-1" data-id="element-148">
                <span className="w-2 h-2 rounded-full bg-green-500 animate-pulse" data-id="element-149" />{' '}
                Acceso Inmediato
              </span>
              <span data-id="element-150">•</span>
              <span data-id="element-151">Pago 100% Seguro</span>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}